// extracted by mini-css-extract-plugin
module.exports = {"grid":"J3oia"};